<template>
  <div :id="`accordion-services-${codigo}-seg`" class="collapse card-body" aria-labelledby="headingSegmentacao"
    :data-parent="`#accordion-services-${codigo}-seg`">
    <div id="headingOne" >
      <div class="custom-header-segmentacao">
        <h5 class="mb-0">

          <button v-for="seg in breadcrumbs" :key="seg.ordem" class="btn btn-link collapsed menu-button"
            @click="voltarAte(seg.ordem)">
            <i class="fa fa-angle-right custom-icon-right"></i>
            <span>{{ seg.nome }}</span>
          </button>
        </h5>
      </div>
    </div>

    <div v-for="(seg, index) in lista" :key="keyOf(seg, index)" class="mt-4 mb-4" model="selectedListasSegmentacoes">
      <div v-if="index > 0">
        <hr>
      </div>

      <h5 class="custom-column">
        <div class="icon-content-trash mt-2" @click="removerSegmentacao(index)">
          <i class="fa-solid fa-trash custom-icon"></i>
        </div>

        <div class="icon-content-trash mt-2" @click="verSegmentacao(index)">
          <i class="fa-solid fa-magnifying-glass custom-icon"></i>
        </div>
        <button :id="`seg-${index}`" class="btn btn-link collapsed"
          style="display:flex; align-items:center; padding-top:5px; padding-bottom:5px;">
          <span class="custom-atribute-span">{{ safe(seg && seg.nome) }}</span>
        </button>
      </h5>
    </div>

    <div v-if="loading" class="p-3">Carregando segmentações...</div>
    <div v-else-if="!loading && !lista.length" class="p-3 text-muted">
      Nenhuma segmentação cadastrada para este serviço.
    </div>
  </div>
</template>

<script>
import * as alertUtils from '@/utils/alert';

export default {
  name: 'SegmentacoesTabs',
  props: {
    codigo: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      lista: [],
      breadcrumbs: [],
      deletingIndex: null
    };
  },
  methods: {
    safe(v, fb = '-') {
      return v === undefined || v === null || v === '' ? fb : v;
    },
    keyOf(seg, i) {
      return seg && (seg.id || seg._id) ? `seg-${seg.id || seg._id}` : `seg-${i}`;
    },
    async carregar() {
      if (!this.codigo) {
        alertUtils.alertError('Serviço inválido para carregar segmentações.');
        return;
      }
      this.loading = true;
      try {
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consultar-servico/${encodeURIComponent(this.codigo)}`;
        const resp = await fetch(url);
        if (!resp.ok) throw new Error('Falha ao consultar serviço');
        const doc = await resp.json();
        const keys = ['segmentacaoServicoApi', 'segmentacoes', 'segmentacao-servico-api', 'segmentação-serviço-api'];
        for (const k of keys) {
          if (Array.isArray(doc[k])) {
            this.lista = doc[k];
            break;
          }
        }
      } catch (e) {
        console.error('Erro ao carregar segmentações:', e);
        alertUtils.alertError('Erro ao carregar segmentações: ' + e);
        this.lista = [];
      } finally {
        this.loading = false;
      }
    },
    async verSegmentacao(index) {
      const seg = this.lista && this.lista[index] ? this.lista[index] : null;
      if (!seg) return;
      this.$emit('onVerSegmentacao', { index, seg });
    },

    async removerSegmentacao(index) {

      if (!this.codigo) {
        return alertUtils.alertError('Serviço inválido.');
      }
      if (index == null || index < 0 || index >= this.lista.length) {
        return alertUtils.alertError('Índice de segmentação inválido.');
      }

      const confirm = await alertUtils.alertConfirmacaoTop(
        'Deseja realmente excluir esta segmentação?',
        'Sim',
        'Não',
        'warning'
      );

      if (!confirm) {
        return;
      }

      try {
        this.deletingIndex = index;

        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/excluir-segmentacao/${this.codigo}/${index}`;

        const resp = await fetch(url, { method: 'GET' });
        if (!resp.ok) throw new Error('Falha na exclusão');

        this.lista.splice(index, 1);

        alertUtils.alertSuccess('Segmentação excluída com sucesso!');
        this.$emit('onRemoverSegmentacao', index, this.lista);
      } catch (e) {
        console.error('Erro ao excluir segmentação:', e);
        alertUtils.alertError('Erro ao excluir segmentação: ' + e);
      } finally {
        this.deletingIndex = null;
      }
    },
    editarSegmentacao(seg) {
      this.$emit('onEditarSegmentacao', seg);
    },
    voltarAte(ordem) {
      const idx = this.breadcrumbs.findIndex(b => b.ordem === ordem);
      if (idx >= 0) this.breadcrumbs = this.breadcrumbs.slice(0, idx + 1);
    }
  },
  watch: {
    codigo: { immediate: true, handler() { this.carregar(); } }
  }
};
</script>

<style scoped></style>
